<app-modal #attachmentmodal [modalConfig]="modalConfig">
  <div class="experience-attachment-modal">
    <div class="form-row col-sm-12">
      <div class="form-row col-sm-12">
        <span class="span-margin-left-5">Max allowed file size 25MB.</span>
      </div>
      <div class="form-group">
        <input type="text" class="form-control" #txtTitle placeholder="Title" [(ngModel)]="portfolioAttachment.title">
      </div>
    </div>
    <div class="form-row col-sm-12">
      <button class="btn btn-sm btn-outline-primary rounded-pill" type="button" (click)="file.click()">
        Upload
        <i class="fa fa-check text-success pl-5" *ngIf="portfolioAttachment.attachmentType == attachmentTypes.File"></i>
      </button>
      <!--Not required at the moment-->
      <!-- <button class="btn btn-sm btn-outline-primary attachment-type-btn col-sm-5 rounded-pill" type="button"
        (click)="portfolioAttachment.attachmentType = attachmentTypes.URL">URL
        <i class="fa fa-check text-success pl-5" *ngIf="portfolioAttachment.attachmentType == attachmentTypes.URL"></i>
      </button> -->
    </div>
  </div>
  <input #file type="file" accept="{{acceptedAttachmentFiles}}" (change)="handleFileUpload(file.files)"
    style="height: 0px;">
  <br>
  <div class="form-row col-sm-12" *ngIf="portfolioAttachment.attachmentType == attachmentTypes.URL">
    <div class="form-group col-sm-12">
      <input type="text" class="form-control" #txtUrl="ngModel" placeholder="URL" [(ngModel)]="portfolioAttachment.url"
        pattern="^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})"
        [class.is-invalid]="txtUrl.invalid && txtUrl.touched" required>
      <div *ngIf="txtUrl.errors && (txtUrl.invalid && txtUrl.touched)">
        <small class="text-danger" *ngIf="txtUrl.errors.required">URL is required.</small>
        <small class="text-danger" *ngIf="txtUrl.errors.pattern">Please provide a valid URL.</small>
      </div>
    </div>
  </div>
  <div class="form-row col-sm-12">
    <span *ngIf="!uploadStatus.success" class="text-danger">{{uploadStatus.status}}</span>
    <p *ngIf="uploadStatus.progress > 0 && uploadStatus.progress < 100"><ngb-progressbar type="success"
        [value]="uploadStatus.progress"></ngb-progressbar></p>
  </div>
</app-modal>